import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import NeuriteGrid from '../../components/neurite_grid';

//actions:
import {
    getCajasCentro, modifyCajaCentro, addCajaCentro, removeCajaCentro
} from '../../actions/cajas_centro_actions';
import {
    openDialog, hideDialog, setSaveState
} from '../../actions';



const styles = theme => ({
    title: {
        margin: '5px 10px',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});



class CentroCajas extends React.Component {

    modifyCajaCentro = (caja) => {
        this.props.setSaveState(true);
        this.props.modifyCajaCentro(caja);
    };

    addCajaCentro = (caja) => {
        this.props.setSaveState(true);
        this.props.addCajaCentro(caja);
    };

    checkCaja = (caja) => {

        if (this.props.cajasCentro.find(c => (c.descr === caja.descr) && (c.id !== caja.id))) {
            this.props.openDialog('SimpleMessage', { message: `Ya existe una caja ${caja.descr} en este centro` }, uuidv4(), false, 'sm');
            return false;
        } else if (!(caja.descr).trim().length) {
            this.props.openDialog('SimpleMessage', { message: `Por favor, introduzca un nombre de caja` }, uuidv4(), false, 'sm');
            return false;
        }
        return true;
    };


    editCaja = (caja) => {

        this.props.openDialog('EditCajaCentro', {
            cajaCentro: caja,
            tiposZona: this.props.tiposZona,
            okHandler: this.modifyCajaCentro,
            checkCaja: this.checkCaja,
            centroid: this.props.centroid
        }, uuidv4());
    };

    newCaja = () => {

        this.props.openDialog('EditCajaCentro', {
            cajaCentro: {},
            tiposZona: this.props.tiposZona,
            okHandler: this.addCajaCentro,
            checkCaja: this.checkCaja,
            centroid: this.props.centroid
        }, uuidv4());

    };

    removeCaja = (caja, index) => {
        this.props.setSaveState(true);
        this.props.removeCajaCentro(caja);
    };

    componentDidMount() {

        this.props.getCajasCentro(this.props.centroid);

    };

    render() {

        const { classes } = this.props;

        return (
            <div >

                <Typography variant="h6" className={classes.title} color={'primary'}>Cajas</Typography>

                <NeuriteGrid
                    id="c_c"
                    columns={[
                        { key: 'descr', name: 'Descripción', editable: false, dragable: false, width: 100 },
                        { key: 'tipoZona', name: 'Tipo de zona', tooltip: 'Zona en la que se encuentra la caja', editable: false, dragable: false, width: 100 },
                        { key: 'canInput', name: '¿Entrada?', tooltip: 'Indica si debe incluirse en los datos de entrada', type: 'bool', editable: false, dragable: false, width: 70 },
                    ]}
                    rows={this.props.cajasCentro? this.props.cajasCentro.filter(c => c.centroId === this.props.centroid): []}
                    buttonEdit={true}
                    buttonDelete={true}
                    buttonNew={true}
                    onNewRowClick={this.newCaja}
                    onEditClick={this.editCaja}
                    onDeleteClick={this.removeCaja}
                    height={200}
                />

            </div>
        );

    };

};

CentroCajas.propTypes = {
    //state
    cajasCentro: PropTypes.array.isRequired,
    tiposZona: PropTypes.array.isRequired,
    //dispatch
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    getCajasCentro: PropTypes.func.isRequired,
    modifyCajaCentro: PropTypes.func.isRequired,
    addCajaCentro: PropTypes.func.isRequired,
    removeCajaCentro: PropTypes.func.isRequired,
    //parameters
    centroid: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
    return {
        cajasCentro: state.cajasCentro.cajasCentro,
        tiposZona: state.tiposZona.tiposzona,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog: openDialog,
        hideDialog: hideDialog,
        getCajasCentro: getCajasCentro,
        modifyCajaCentro: modifyCajaCentro,
        addCajaCentro: addCajaCentro,
        removeCajaCentro: removeCajaCentro,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(CentroCajas));